"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var INVITE_USER_FORM = {
  title: 'Add a member',
  saveLabel: 'Add',
  fields: {
    email: {
      kind: 'email'
    }
  }
};
var OrgContentHubList = /*#__PURE__*/function () {
  OrgContentHubList.$inject = ["$rootScope", "orgService", "eventService", "userService", "modalService"];
  /* @ngInject */
  function OrgContentHubList($rootScope, orgService, eventService, userService, modalService) {
    _classCallCheck(this, OrgContentHubList);
    this.orgService = orgService;
    this.eventService = eventService;
    this.userService = userService;
    this.modalService = modalService;
    this.currentUser = userService.getCurrentUser();
    this.loading = true;
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.memberInEvents = this.currentUser.roles.filter(function (_ref) {
      var type = _ref.type,
        role = _ref.role,
        event_id = _ref.event_id;
      return type === 'event_permission' && role !== 'revoked' && event_id;
    }).map(function (role) {
      return role.event_id;
    });
  }
  _createClass(OrgContentHubList, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this = this;
      if (changes.organisation && this.organisation) {
        this.loading = true;
        this.canAddMembersToTeam = this.userService.hasPermission('access_modification_realms.add_event_team_member', {
          org_id: this.organisation._id
        });
        this.orgService.getAllOrgContentHubs(this.organisation.name).then(function (data) {
          return _this.contentHubs = data;
        }).catch(function (error) {
          console.error(error);
          _this.setFlashMessage('Failed to load content hubs', 'danger');
        }).finally(function () {
          return _this.loading = false;
        });
      }
    }
  }, {
    key: "joinContentHub",
    value: function joinContentHub(hub) {
      var _this2 = this;
      if (!this.canAddMembersToTeam) {
        return;
      }

      // needs to be called on cloud node
      this.eventService.addEventTeamMember(hub.id, this.currentUser.name, 'manager', hub.node).then(function () {
        _this2.setFlashMessage("You were added to ".concat(hub.name));
        _this2.memberInEvents.push(hub.id);
      }).catch(function (error) {
        console.error(error);
        _this2.setFlashMessage('Failed to join the content hub team', 'danger');
      });
    }
  }, {
    key: "inviteToContentHub",
    value: function inviteToContentHub(hub) {
      var _this3 = this;
      if (!this.canAddMembersToTeam) {
        return;
      }
      this.modalService.openModalWithForm(INVITE_USER_FORM).then(function (model) {
        var email = model.email;
        // needs to be called on cloud node
        _this3.eventService.addEventTeamMember(hub.id, email, 'manager', hub.node).then(function () {
          return _this3.setFlashMessage("".concat(email, " was added to ").concat(hub.name));
        }).catch(function (error) {
          console.error(error);
          _this3.setFlashMessage("Failed to add ".concat(email, " to team"), 'danger');
        });
      });
    }
  }]);
  return OrgContentHubList;
}();
module.exports = angular.module('backstage.components.orgs.view-org.content-hub-list', ['backstage.services']).component('bsOrgContentHubList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-content-hub-list/org-content-hub-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgContentHubList
}).name;